// extracted by mini-css-extract-plugin
export default {"root":"TableColumn__root---b99T"};